module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('figure', {
    attrs: {
      "id": _vm.figureAttr.id
    }
  }, [_c('label', {
    domProps: {
      "innerHTML": _vm._s(_vm.figureAttr.label)
    }
  }), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": _vm.figureAttr.url,
      "alt": _vm.figureAttr.alt
    }
  })]), _vm._v(" "), _c('figcaption', {
    domProps: {
      "innerHTML": _vm._s(_vm.figureAttr.caption)
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5bf596c6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/article-items/ContentFigureComponent.vue
// module id = 1434
// module chunks = 1